import { Card } from 'antd'
import React from 'react'

const DRCWFields_ANSI = ({ isFree }) => {

    return (
        <Card title='Hello World'>
            
        </Card>
    )
}

export default DRCWFields_ANSI
